import axios, { AxiosResponse } from "axios";
import UserService from "./UserService";
import ClaimModel from "../models/Claim";

const API_BASE_URL = window._env_.REACT_APP_PAROLA_API_URL;
const API_RESOURCE = "claim/";

export default class OrderService {
  public static async claim(claim: ClaimModel): Promise<string | null> {
    try {
      const response: AxiosResponse<string> = await axios.post(
        API_BASE_URL + API_RESOURCE,
        claim,
        {
          headers: UserService.getAuthHeader(),
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}